<template>
  <div class="page">
    <van-nav-bar title="实习日志" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <van-tabs type="line" v-model="active" animated color="#0088F8" @click="tabsChange">
      <van-tab title="写日志">
        <van-notice-bar color="#F85352" background="#fae6e5" left-icon="info-o" mode="closeable">只能提交最近{{delayDay}}天的实习日志记，提交时间限制在每日{{lastTime}}之前</van-notice-bar>
        <van-form @submit="onSubmit" style="height: calc(100vh - 130px)">
          <van-field v-model="form.bt" name="标题" label="标题" input-align="right" error-message-align="right" placeholder="请输入" :rules="[{ required: true, message: '请填写标题' }]" />
          <van-field v-model="form.ytjsj" is-link readonly label="选择日期" input-align="right" error-message-align="right" placeholder="请选择" @click="showDatePicker" :rules="[{ required: true, message: '请选择日期' }]" />
          <van-field style="margin-top: 10px" class="textarea" v-model="form.nr" rows="5" autosize label="内容"  type="textarea" placeholder="请输入内容" :rules="[{ required: true, message: '请输入日志内容' }]" />
          <van-field name="uploader" label="">
            <template #input>
              <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1" :after-read="upload" v-model="fileList" />
            </template>
          </van-field>
          <div class="map">
            <el-amap ref="map" class="amap-box" :vid="'amap-vue'" :amap-manager="amapManager" :plugin="plugin"></el-amap>
          </div>
          <div class="position" v-if="schoolCode !== '10848'">
            <div class="title">
              <div>您当前所在位置</div>
              <div style="color: #0189F9;" @click="rePosition">重新定位</div>
            </div>
            <div class="content">
              <van-loading v-if="form.dz == ''" type="spinner" size="14" />
              {{ form.dz || '定位获取中…' }}
            </div>
          </div>
          <div class="button-box">
            <van-button round type="info" native-type="submit">提交</van-button>
          </div>
        </van-form>
      </van-tab>
      <van-tab title="历史日志">
        <div class="total-box">
          <div class="title" @click="showPicker = true">
            <div class="left">{{ month }}月汇总</div>
            <!-- <img src="../../static/right-arrow.png" /> -->
            <van-icon name="arrow" />
          </div>
          <div class="content">
            <div class="item-box" v-for="(item, index) in pageData.totalList" :key="'total' + index">
              <div class="top">{{ item.value }}</div>
              <div class="bottom">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <!-- 月历 -->
        <div class="calendar">
          <div class="title">
            每日记录
            <p>({{ month }}月)</p>
          </div>
          <Calendar @onDayClick="dateClick" ref="ren" :headerBar="false" :year-and-month-to-see="endTime" :mark-days="pageData.dayList" :open="false" :disabledAfter="true"></Calendar>
          <div v-if="!dayObj.hasDate" class="empty-sign">
            <img src="../../../../assets/images/no_sign.png" alt="" />
            <div>未提交日志</div>
          </div>
          <!-- 当日评阅记录 -->
          <div class="comment" v-else>
            <div class="status">
              指导教师评阅：
              <p :style="{ color: getCommentStatusColor }">{{ getCommentStatus }}</p>
            </div>
            <div class="comment-content" v-if="dayObj.status == '2'">
              <div class="comment-title">评语</div>
              <div>{{ dayObj.comment }}</div>
            </div>
          </div>
        </div>
        <!-- 日志详细 -->
        <div class="daily-content" v-if="dayObj.hasDate" :style="{ paddingBottom: getCanEditStatus ? '0' : '15px' }">
          <div class="title">标题</div>
          <div class="content">
            {{ dayDetail.bt }}
          </div>
          <div class="title">内容</div>
          <div class="content">
            {{ dayDetail.nr }}
          </div>
          <div class="title">图片</div>
          <div class="content">
            <img :src="dayDetail.base64" alt="" />
          </div>
          <div class="title">位置</div>
          <div class="content">
            {{ dayDetail.dz }}
          </div>
          <div class="edit-button" v-if="getCanEditStatus" @click="editData">
            <van-icon name="edit" />
            <div>修改日志</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 选择月历月份 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker v-model="currentDate" type="year-month" title="选择年月" :min-date="sxStartTime"  :max-date="sxEndTime" @cancel="showPicker = false" :formatter="formatter" @confirm="chooseMonth" />
    </van-popup>
    <!-- 选择实习日志日期 -->
    <van-popup v-model="showPickerDate" position="bottom">
      <van-datetime-picker v-model="currentDate" type="date" title="选择日志日期" :min-date="minDate" :max-date="maxDate" @cancel="showPickerDate = false" @confirm="chooseDate" />
    </van-popup>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
import Calendar from './components/calendar'
import { AMapManager } from 'vue-amap'
import { mapGetters } from 'vuex'
let amapManager = new AMapManager()
export default {
  components: {
    Calendar,
  },
  data() {
    let self = this
    return {
      schoolCode:sessionStorage.getItem("schoolCode"),
      isEdit: false,
      amapManager,
      plugin: [
        {
          pName: 'Geolocation',
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          buttonPosition: 'RB', //定位按钮的停靠位置
          zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                if (status == 'complete') {
                  self.complete(result)
                } else {
                  self.$toast.fail('定位失败！')
                }
              })
            },
          },
        },
      ],
      active: 0,
      fileList: [],
      showEmpty: false,
      pageData: {
        totalList: [],
        dayList: [],
      },
      form: {
        sxjhid: '',
        dz: '',
        nr: '',
        bt: '',
        ytjsj: '',
        sxrzid: '', // 只在编辑的时候传
        file: '',
      },
      showPicker: false,
      showPickerDate: false,
      currentDate: new Date(),
      nowDate: new Date(),
      minDate: new Date(),
      maxDate:new Date(),
      sxStartTime:null,
      sxEndTime:null,
      startTime: `${new Date().format('yyyy-MM')}-01`, // 筛选日历的开始时间，默认本月一号
      endTime: new Date().format('yyyy-MM-dd'), // 筛选日历的结束时间，默认今日
      dayObj: {},
      month: new Date().getMonth() + 1,
      nowMonth: new Date().getMonth() + 1,
      date: new Date().format('yyyy-MM'),
      delayDay: 0,
      dayDetail: {
        base64: '',
        bt: '',
        dz: '',
        filepath: '',
        nr: '',
      },
      lastTime: '23:29'
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
    }),
    getCommentStatus() {
      if (this.dayObj.status == '1') {
        return '评阅中'
      } else if (this.dayObj.status == '2') {
        return this.dayObj.level
      }
    },
    getCommentStatusColor() {
      if (this.dayObj.status == '1') {
        return '#999999'
      } else if (this.dayObj.status == '2') {
        return '#F85352'
      }
    },
    getCanEditStatus() {
      let dif = (new Date().getTime() - new Date(this.dayObj.date).getTime()) / 24 / 3600 / 1000
      if (dif < this.delayDay - 1 && this.dayObj.status == '1') {
        // 在可编辑的时间范围内，并且状态还是未评阅
        return true
      }
      return false
    },
  },
  methods: {
    /**
     * @description: 地图定位完成
     * @param {Object} result 定位结果
     */
    complete(result) {
      this.form.dz = result.formattedAddress
    },

    /**
     * @description: 打开选择日志日期弹窗，只在新增模式下可以打开
     */
    showDatePicker() {
      if (!this.isEdit) {
        this.showPickerDate = true
      }
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    },
    chooseMonth(e) {
      this.showPicker = false
      this.date = new Date(e).format('yyyy-MM')
      this.month = new Date(e).getMonth() + 1
      this.startTime = `${this.date}-01`
      if (this.month == this.nowMonth) {
        // 本月只截止到本月本天
        this.endTime = new Date().format('yyyy-MM-dd')
      } else {
        this.endTime = new Date(this.date.split('-')[0], this.month, 0).format('yyyy-MM-dd')
      }
      this.$refs.ren.changYearMonth(this.date.split('-')[0], this.month)
      this.getDailyData()
    },

    /**
     * @description: 选择日志日期
     * @param {Date} e 选择的日期
     */
    chooseDate(e) {
      this.showPickerDate = false
      this.form.ytjsj = new Date(e).format('yyyy-MM-dd')
    },

    /**
     * @description: 重新定位事件，获取地图插件通过重新调用方法，获取地址
     */
    rePosition() {
      this.form.dz = ''
      this.$refs.map.$plugins['AMap.Geolocation'].getCurrentPosition((status, result) => {
        if (status == 'complete') {
          this.complete(result)
        } else {
          this.$toast.fail('定位失败！')
        }
      })
    },
    async dateClick(e) {
      let index = this.pageData.dayList.findIndex(day => day.date === e.date)
      if (index != -1) {
        this.dayObj = this.pageData.dayList[index]
        if (this.pageData.dayList[index].id != '') {
          this.getDailyDetail(this.pageData.dayList[index].id)
        }
      }
    },
    /**
     * @description: tab监听，当tabs为1的时候请求日历接口
     * @param {*} e
     * @return {*}
     */
    tabsChange(e) {
      if (e == 1) {
        this.currentDate = new Date(this.endTime);
        this.getDailyData()
        // 默认获取今天的数据
      }
    },

    /**
     * @description: 文件上传，通过上传组件，直接将file赋值
     * @param {*} e
     * @return {*}
     */
    upload(e) {
      this.form.file = e.file
    },

    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    editData() {
      this.isEdit = true
      this.form = {
        sxjhid: this.sxjhid,
        dz: '',
        nr: this.dayDetail.nr,
        bt: this.dayDetail.bt,
        ytjsj: this.dayObj.date,
        sxrzid: this.dayObj.id, // 只在编辑的时候传
        file: '',
      }
      this.fileList.push({
        content: this.dayDetail.base64,
      })
      this.active = 0
      this.rePosition()
    },

    /**
     * @description: 表单提交
     * @param {*}
     * @return {*}
     */
    async onSubmit() {
      if(this.form.nr.indexOf("'") != -1 || this.form.nr.indexOf('"') != -1){
        this.$toast('输入内容存在非法字符，请检查后重新提交!')
        return false;
      }
      this.form.sxjhid = this.sxjhid
      const res = await iApi.postDailyData(this.form)
      if (res.code == '1') {
        this.$toast('提交实习日志成功')
        this.form = {
          sxjhid: '',
          dz: '',
          nr: '',
          bt: '',
          ytjsj: '',
          sxrzid: '', // 只在编辑的时候传
          file: '',
        }
        this.active = 1
        this.getDailyData()
        // 编辑后返回原页面
        this.isEdit = false
        this.fileList = []
        if(this.dayObj != {}){
          this.$refs.ren.choose = this.dayObj.date
          this.getDailyDetail(this.dayObj.id)
        }
      }
    },
    async getDailyData() {
      const res = await iApi.getDailyList({
        sxjhid: this.sxjhid,
        cxkssj: this.startTime,
        cxjssj: this.endTime,
      })
      this.pageData = res.data
      // 自动触发一次dateClick事件
      this.dateClick({ date: this.endTime, week: '' })
    },
    async getDailyDetail(id) {
      const res = await iApi.getDailyDetail({
        sxrzid: id
      })
      this.dayDetail = res.data
    },
  },
  async created() {
    const res = await iApi.getDailyTime({ sxjhid: this.sxjhid })
    this.delayDay = parseInt(res.data.delayDay)
    this.lastTime = res.data.endingTime
    //this.minDate = new Date(new Date().getTime() - (this.delayDay - 1) * 24 * 3600 * 1000)
   // this.form.ytjsj = new Date().format('yyyy-MM-dd')
    if(res.data.minDateStr==''||res.data.maxDateStr==''){
      this.form.ytjsj = "";
      this.currentDate = null;
      this.minDate = null;
      this.maxDate = null;
    }else{
      this.minDate = new Date(res.data.minDateStr);
      this.maxDate = new Date(res.data.maxDateStr);
      this.form.ytjsj = res.data.maxDateStr;
      this.currentDate = this.maxDate;
    }
    this.sxStartTime = new Date(res.data.sxStartTime);
    this.sxEndTime = new Date(res.data.sxEndTime);
    this.month = res.data.month;
   this.startTime = res.data.cxStartDate;
   this.endTime = res.data.cxEndDate;
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
}
.empty {
  // margin-top: 167px;
  height: calc(100vh - 86px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #666666;
  text-align: center;
  img {
    width: 159px;
    height: 154px;
    margin-bottom: 30px;
  }
  .button {
    width: 232px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    margin-top: 50px;
  }
}
.item-box {
  width: 315px;
  min-height: 50px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto 0;
  padding: 12px 15px;
  .title-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      // width: 280px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .status {
      margin-left: 10px;
      min-width: 46px;
      height: 20px;
      border: 1px solid #41b29c;
      border-radius: 10px;
      text-align: center;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #41b29c;
    }
  }
  .date {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    margin: 5px 0;
  }
  .tip-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    p {
      color: #0088f8;
    }
  }
}
.button-box {
  width: 375px;
  height: 70px;
  background: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .van-button {
    width: 345px;
    height: 50px;
    background: #0189f9;
    border-radius: 25px !important;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
  }
}
.map {
  overflow: hidden;
  width: 0px;
  height: 0px;
}
.position {
  margin-top: 10px;
  width: 345px;
  background: #ffffff;
  padding: 15px;
  .title {
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
  }
  .content {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #b2b2b2;
    margin-top: 5px;
    display: flex;
    align-items: center;
    .van-loading {
      position: relative;
      left: 0;
      margin-right: 10px;
    }
  }
}
.textarea {
  flex-direction: column;
  height: 200px;
  overflow-y:auto;
}
.total-box {
  width: 345px;
  height: 132px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto;
  .title {
    display: flex;
    justify-content: space-between;
    padding: 16px 20px 0 20px;
    .left {
      font-weight: bold;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
    }
  }
  .content {
    display: flex;
    .item-box {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .top {
        font-weight: bold;
        font-family: PingFangSC-Semibold;
        font-size: 26px;
        line-height: 37px;
        color: #333333;
      }
      .bottom {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        line-height: 20px;
        color: #666666;
      }
    }
  }
}
.calendar {
  width: 345px;
  // height: 566px;
  // padding-bottom: 25px;
  background: #ffffff;
  border-radius: 8px;
  margin: 0 auto;
  .title {
    padding-top: 18px;
    margin-left: 18px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    p {
      font-size: 14px;
      color: #999999;
    }
  }
  .empty-sign {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 76px;
      height: 76px;
      margin-bottom: 24px;
    }
    div {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      text-align: center;
      line-height: 18px;
    }
  }
  .comment {
    padding: 15px;
    .status {
      display: flex;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      p {
        color: #f85352;
      }
    }
    .comment-content {
      margin-top: 15px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      .comment-title {
        color: #999999;
        margin-bottom: 5px;
      }
    }
  }
}
.daily-content {
  width: 315px;
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  margin: 10px auto;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  .title {
    color: #999999;
    margin-bottom: 5px;
  }
  .content {
    margin-bottom: 10px;
    img {
      width: 70px;
      height: 70px;
      border-radius: 4px;
      display: block;
      overflow: hidden;
    }
  }
  .edit-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border-top: 1px solid #e5e5e5;
    i {
      margin-right: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/daily.vue